import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useGlMap } from '../../contexts/context';
import { useMobile } from '../../../common/components/responsive/Responsive';
import { selectHeight as selectWizardHeight } from '../../../common/store/wizard';

export const fullscreenPadding = { top: 0, right: 0, bottom: 0, left: 0 };
export const sidepanelPadding = { top: 0, right: 0, bottom: 0, left: 424 };

export function useMapPadding({
  desktopPadding = sidepanelPadding,
  mobilePadding = fullscreenPadding,
  animationRunner,
}: {
  desktopPadding?;
  mobilePadding?;
  animationRunner?;
} = {}) {
  const glMap = useGlMap();
  const isMobile = useMobile();
  const wizardHeight = useSelector(selectWizardHeight);

  const padding = useMemo(
    () =>
      isMobile
        ? {
            ...mobilePadding,
            bottom: wizardHeight
              ? wizardHeight + mobilePadding.bottom
              : mobilePadding.bottom,
          }
        : desktopPadding,
    [isMobile, desktopPadding, mobilePadding, wizardHeight],
  );

  useEffect(() => {
    if (!glMap) {
      return;
    }

    if (animationRunner) {
      return animationRunner(() => glMap.setPadding(padding), {
        replaceRunningAnimation: false,
      });
    } else {
      glMap.setPadding(padding);
    }
  }, [glMap, padding, animationRunner]);

  return padding;
}
